import React, { Component } from 'react';
import { withAsyncActions } from 'react-async-client';
import { message } from 'antd';
import { Modal } from 'antd';

import { modalFormPropTypes } from 'components/common/ModalForm';
import UploadFile from 'components/common/form/UploadFile';
import { postDocument } from 'actions/asyncActions';
import { FILE } from 'constants/urls';
import { getActionUrl } from 'utils/http';

@withAsyncActions({ postAction: postDocument.withSuccessHandler((props) => props.modal.onCancel()) })
export default class DocumentModal extends Component {
    static propTypes = modalFormPropTypes;

    onChangeUpload = info => {
        const { status, name } = info.file;
        const { postAction } = this.props;
        switch (status) {
            case 'done':
                const { id } = info.file.response;
                message.success(`${name} файл успешно загружен.`);
                postAction.dispatch({ name, file: { id } });
                break;
            case 'error':
                message.error(`Ошибка загрузки файла ${name}.`);
                break;
            default:
        }
    }

    render() {
        const { modal } = this.props;

        return (
            <Modal {...modal} title={'Добавить документ'} footer={null}>
                <UploadFile
                    onChangeUpload={this.onChangeUpload}
                    name="file"
                    url={getActionUrl(FILE)}
                />
            </Modal>
        );
    }
}
